module.exports = __webpack_public_path__ + "static/media/Autoset_logo_1000_b.99c66801.png";